import React from 'react';
import { Controller, Control, FieldValues, type RegisterOptions } from 'react-hook-form';
import PhoneInput from 'react-phone-input-2';

// TODO @EV: fix this styling imports
import './styles.less';
import type { NestedPropertyPaths } from './types';

type PhoneInputName<T> =
  | Extract<{ [K in keyof T]: T[K] extends string ? K : never }[keyof T], string>
  | NestedPropertyPaths<T>;

interface ControlledPhoneInputProps<T extends FieldValues> {
  error: boolean;
  name: PhoneInputName<T>;
  country?: string;
  label?: string;
  required?: boolean;
  control: Control<T>;
  rules?: RegisterOptions;
  errorMessage?: string;
}

export const ControlledPhoneInput = <T extends FieldValues>({
  country = 'us',
  label = 'Phone Number',
  name,
  required = false,
  control,
  error,
  rules,
  errorMessage = 'Please enter a valid phone number',
}: ControlledPhoneInputProps<T>) => (
  <Controller
    name={name}
    control={control as Control<FieldValues>}
    rules={rules}
    render={({ field }) => (
      <PhoneInput
        country={country}
        // @NOTE-EV TODO: default error message is currently not displaying
        defaultErrorMessage={errorMessage}
        containerClass={`phone-input-2 ${error ? 'phone-input-2--error' : ''}`}
        value={field.value}
        onChange={(value) => field.onChange(value)}
        specialLabel={`${label}${required ? ' *' : ''}`}
      />
    )}
  />
);
